import { api } from "./client";
import type { ProductListParams, ProductCompanyListVO, ProductCategoryList } from "./types/product";

/**
 * 获取产品列表
 * GET /api/v1/product/list
 */
export async function getProductList(params?: ProductListParams): Promise<any> {
  return api.get("/product/list", {
    params,
  });
}

/**
 * 获取产品详情
 * GET /api/v1/product/info/{productCode}
 */
export async function getProductInfo(productCode: string): Promise<any> {
  return api.get(`/product/info/${productCode}`);
}

/**
 * 获取产品公司列表
 * GET /api/v1/product/company/list
 */
export async function getProductCompanyList(): Promise<ProductCompanyListVO[]> {
  return api.get("/product/company/list");
}

/**
 * 获取产品分类列表
 * GET //api/v1/product/category/list
 */
export async function getProductCategoryList(): Promise<ProductCategoryList[]> {
  return api.get("/product/category/list");
}

/**
 * 获取 FNA 产品列表
 * PUT /api/v1/advisor/order/fna-product-list
 */
export async function getFnaProductList(params?: ProductListParams): Promise<any> {
  return api.put("/advisor/order/fna-product-list", params);
}
